function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M33 17H17c-1.1 0-1.99.9-1.99 2L15 31c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V19c0-1.1-.9-2-2-2zm0 14H17V21l8 5 8-5v10zm-8-7-8-5h16l-8 5z",
  id: "h54sooztva"
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13 13h24v24H13z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "19hago9a5b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#h54sooztva"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#h54sooztva"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#19hago9a5b)",
  fill: "#72246C"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h50v50H0z"
})));
const SvgIconUiIconsIcEmail = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 50,
  height: 50,
  viewBox: "0 0 50 50",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUiIconsIcEmail, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-ui-icons-ic-email.56dae3f4.svg";
export { ForwardRef as ReactComponent };